import { render } from "./NoLongerGiving.vue?vue&type=template&id=90d27e40&scoped=true"
import script from "./NoLongerGiving.vue?vue&type=script&lang=js"
export * from "./NoLongerGiving.vue?vue&type=script&lang=js"

import "./NoLongerGiving.vue?vue&type=style&index=0&id=90d27e40&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d27e40"]])

export default __exports__